import { render, staticRenderFns } from "./Table1.vue?vue&type=template&id=2b54945c&scoped=true&"
import script from "./Table1.vue?vue&type=script&lang=js&"
export * from "./Table1.vue?vue&type=script&lang=js&"
import style0 from "./Table1.vue?vue&type=style&index=0&id=2b54945c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54945c",
  null
  
)

export default component.exports